import React from 'react';
import { ClipboardListIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { images } from '../data/checkout';
export function Hero() {
  return <header className="bg-canvas px-4 pb-16 pt-6 sm:px-6 md:pb-24 md:pt-10" data-id="element-149" data-mp="9lv16qmocfvu">
      <div className="mx-auto max-w-5xl text-center" data-id="element-150" data-mp="4m8msdv40tlg">
        <div className="inline-flex items-center gap-2.5" data-id="element-151" data-mp="4njnu5x67n8v">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand text-white" data-id="element-152" data-mp="129qs1epkbdkp">
            <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-153" data-mp="xbfmhg6avp8a" />
          </span>
          <span className="font-serif text-xl font-bold text-ink" data-id="element-154" data-mp="sai5h6x1118d">Obesity Clinical Blueprint™</span>
        </div>

        <p className="mx-auto mt-7 max-w-md text-[13px] font-bold uppercase tracking-[0.14em] text-brand" data-id="element-155" data-mp="nb6n5th0hnoo">
          The practical clinical system for structured obesity care
        </p>

        <h1 className="mx-auto mt-3 max-w-4xl font-serif text-[34px] font-bold leading-[1.08] text-ink sm:text-5xl md:text-6xl" data-id="element-156" data-mp="3825wymt9u1js">
          Organize the 6 key stages of adult obesity care in{' '}
          <em className="text-brand" data-id="element-157" data-mp="3o7vllomspvze">under 15 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-158" data-mp="39acwuma4biry">
          A practical, step-by-step clinical reference system created by <strong className="text-ink" data-id="element-159" data-mp="3e7uzxw1gf3s1">Dr. Henry Wells</strong>{' '}
          to help healthcare professionals organize obesity assessments, treatment reviews, and follow-up. Includes{' '}
          <strong className="text-ink" data-id="element-160" data-mp="359j6lm97drvw">6 clinical volumes</strong>, <strong className="text-ink" data-id="element-161" data-mp="2qk3m2o09mion">5 professional tools</strong>{' '}
          and a <strong className="text-ink" data-id="element-162" data-mp="2qi0lxb5ef967">visual clinical decision framework</strong>.
        </p>

        <figure className="-mx-2 mt-8 sm:mx-auto sm:max-w-3xl" data-id="element-163" data-mp="2vgllr9gqnqu4">
          <img src={images.hero} alt="The six volumes and five exclusive tools of Obesity Clinical Blueprint™" className="w-full" data-id="element-164" data-mp="2hkglg4fd1gwn" />
          <figcaption className="mt-2 text-sm font-medium text-muted" data-id="element-165" data-mp="s2b73w324f43">
            The Six Volumes and Five Exclusive Tools of Obesity Clinical Blueprint™
          </figcaption>
        </figure>

        <div className="mt-8" data-id="element-166" data-mp="ibgn6yda9rlt">
          <CTAButton id="first-cta" label="Yes, I want Obesity Clinical Blueprint™" note="Instant Download · One-Time Payment of $27 USD · Lifetime Access to This Edition · 7-Day Money-Back Guarantee" data-id="element-167" data-mp="icrn2n3lyf7n" />
        </div>

        <Countdown data-id="element-168" data-mp="161jbd3e2udf5" />
      </div>
    </header>;
}